export default __webpack_public_path__ + "static/char-sp02-anr-cd3e606a5c5e199b8a1a5568768c2eb8.webp";